import React, { useState } from 'react';
import { Input, message, Modal, Upload, UploadFile } from 'antd';
import { useStore } from '@/app/providers/StoreProvider';
import { observer } from 'mobx-react-lite';
import { useNavigate } from 'react-router';
import { handleInvite } from '@/shared/utils/referralLink';

import { Loading } from '@/shared/ui/Loading';
import ImgTeamBorder from '@/shared/pictures/team_border.png';
import ImgEmptyImg from '@/shared/pictures/empty_img.png';
import ImgClose from '@/shared/pictures/close.svg';




export const TeamCreatePage = observer(() => {
  const navigate = useNavigate();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [name,setName] = useState<string>('');
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const {teamStore} = useStore();
  const {link, loadingTeams, createTeam, getInviteLink} = teamStore;


  const handleCancel = () => {
    setIsModalOpen(false);
    navigate('/menu/teams');
  };

  const inviteMember = async() => {
    handleInvite(link, 'Создал команду в приложении Александра Овечкина в Telegram. Присоединяйся, будем участвовать в турнирах. Погнали?');
    setIsModalOpen(false);
  };


  const handleSearch = (e:React.ChangeEvent<HTMLInputElement>) => {
    setName(e.target.value);
  }

  const handleChange = (info: { file: UploadFile; fileList: UploadFile[] }) => {
    const updated = info.fileList.map(file => {
      if (!file.preview && file.originFileObj) {
        file.preview = URL.createObjectURL(file.originFileObj);
      }
      return file;
    });
    setFileList(updated);
  };

  const maxSize = 10 * 1024 * 1024;
  const allowedTypes = [
      'image/jpeg',
      'image/png'
  ];

  const beforeUpload = async(file: File) => {
    if (!allowedTypes.includes(file.type)) {
      message.error('Формат изображения не поддерживается');
      return Upload.LIST_IGNORE;
    }
    if (file.size > maxSize) {
      message.error('Превышен размер изображения');
      return Upload.LIST_IGNORE;
    }
    return file;
  };


  const handleUpload = async () => {
    if ((!fileList.length || !fileList[0].originFileObj) ) {
      message.error('Загрузите эмблему');
      return;
    }
    if (name === '') {
      message.error('Укажите название команды');
      return;
    }
    const file = fileList[0].originFileObj;
    const formData = new FormData();
    formData.append('file', file);

    const idCreated = await createTeam(name,formData);
    if(idCreated){
      await getInviteLink();
      setIsModalOpen(true);
    }
  };

  if(loadingTeams) return <Loading/>
  return (
    <div className='teamcreate-page'>
      <div className="container">
        <h1 className='teamcreate_title'>Создание команды</h1>
        <div className='teamcreate_file-block'>


        <div className='teamcreate_img-block' >
            {fileList.length > 0?
              fileList.map(file => (
                <div key={file.uid}>
                  <img className='teamcreate_img' src={file.preview} alt={file.name} key={file.uid}/>
                  <img className='teamcreate_border' src={ImgTeamBorder} alt="team-img"/>
                </div>
              ))
              :<img className='teams-list_img'
                    src={ImgEmptyImg}
                    alt='empty' />
            }
          </div>

          <div className='teamcreate_file-info'>
            <h2 className='teamcreate_file-title'>Добавьте эмблему своей <br/> будущей команды!</h2>
            <p className='teamcreate_file-text'>максимальный размер файла 10 МБ</p>
            <Upload
              showUploadList={false}
              beforeUpload={beforeUpload}
              onChange={handleChange}
              fileList={fileList}
              maxCount={1}
            >
              <div className="teamcreate_file-button">Загрузить</div>
            </Upload>
          </div>
        </div>

        <Input className='teamcreate_input' placeholder="Введите название команды" onChange={handleSearch} value={name} />
        <div className='teamcreate_buttons'>
          <div className='teamcreate_button blue' onClick={()=>handleUpload()}>Создать команду</div>
        </div>


      <Modal
        title = {null}
        closable={{ 'aria-label': 'Custom Close Button' }}
        open={isModalOpen}
        footer={null}
        closeIcon={<img src={ImgClose} onClick={()=>handleCancel()}/>}
      >
        <div className='modal'>
          <div className='modal_body'>
            { fileList.map(file => (
              <div className='modal_img-block' key={file.uid}>
              <img className='modal_img' src={file.preview} alt={file.name} key={file.uid}/>
              <img className='modal_border' src={ImgTeamBorder} alt="team-img"/>
            </div>
            ))}

            <h3 className='modal_title'>Поздравляем теперь вы часть команды: “{name}”</h3>
            <p className='modal_text'>Приглашайте участников и соревнуйтесь с другими командами!</p>
          </div>

          <div className='modal_buttons'>
            <button type='button' className='modal_button button_blue' onClick={inviteMember}>Пригласить участников</button>
            <button type='button' className='modal_button button_gray' onClick={handleCancel}>Закрыть</button>
          </div>
        </div>
      </Modal>
    </div>
    </div>
  )
});
